import { render, staticRenderFns } from "./PriceAnnouncementModal.vue?vue&type=template&id=2f5bd6c5&"
import script from "./PriceAnnouncementModal.vue?vue&type=script&lang=js&"
export * from "./PriceAnnouncementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports